import { render, staticRenderFns } from "./addPoints.vue?vue&type=template&id=d4ddf9d2&scoped=true&"
import script from "./addPoints.vue?vue&type=script&lang=js&"
export * from "./addPoints.vue?vue&type=script&lang=js&"
import style0 from "./addPoints.vue?vue&type=style&index=0&id=d4ddf9d2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4ddf9d2",
  null
  
)

export default component.exports